(() => {
    const sliderElements = document.querySelectorAll('[data-vd-component="slider"]');
    if (sliderElements.length === 0) return;

    sliderElements.forEach((sliderElement) => {
        const sliderId = sliderElement.getAttribute("data-slider-id");
        const loop = sliderElement.getAttribute("data-slider-loop") === "true";
        const pagination = sliderElement.getAttribute("data-pagination") === "true";
        const paginationType = sliderElement.getAttribute("data-pagination-type");
        const autoplay = sliderElement.getAttribute("data-slider-autoplay") === "true";
        const autoplayDelay = parseInt(sliderElement.getAttribute("data-slider-autoplay-delay"), 10);
        const effect = sliderElement.getAttribute("data-slider-effect");
        const fadeCrossFade = sliderElement.getAttribute("data-slider-cross-fade") === "true";
        const speed = parseInt(sliderElement.getAttribute("data-slider-speed"), 10);
        const navigation = sliderElement.getAttribute("data-slider-navigation") === "true";
        const defaultSpace = parseInt(sliderElement.getAttribute("data-slider-space"), 10) || 0;
        const centeredSlides = sliderElement.getAttribute("data-centered-slides") === "true";
        const hasVideoAutoPlay = sliderElement.getAttribute("data-has-video-autoplay") === "true";
        const slidesPerGroupAttr = parseInt(sliderElement.getAttribute("data-slider-slides-group"), 10);
        const slidesPerGroup = Number.isNaN(slidesPerGroupAttr) || slidesPerGroupAttr < 1 ? 1 : slidesPerGroupAttr;

        const numOfSlidesAttr = sliderElement.getAttribute("data-slider-slides");
        let numOfSlides;

        let initialSlideIndex = 0;
        let slideChangeVideoHandler = null;

        function getContainerPaddingLeftPx() {
            const container = sliderElement.closest(".widget-container");
            if (!container) return 0;
            const v = parseFloat(getComputedStyle(container).paddingLeft);
            return Number.isFinite(v) ? v : 0;
        }

        function getEndOffsetPx() {
            const attr = sliderElement.getAttribute("data-slider-end-offset");
            if (attr != null && attr !== "") {
                const v = parseFloat(attr);
                if (Number.isFinite(v)) return v;
            }
            return getContainerPaddingLeftPx();
        }

        function applyEndOffset(swiper) {
            if (!swiper) return;
            const endOffset = getEndOffsetPx();
            swiper.params.slidesOffsetAfter = endOffset;
            if (swiper.originalParams) swiper.originalParams.slidesOffsetAfter = endOffset;
            swiper.update();
        }

        (function resolveInitialSlide() {
            const attr = sliderElement.getAttribute("data-initial-slide");
            if (!attr) return;

            const pickBreakpointValue = (map) => {
                const w = window.innerWidth;
                if (w >= 1536 && map["2xl"] != null) return map["2xl"];
                if (w >= 1280 && map["xl"] != null) return map["xl"];
                if (w >= 1024 && map["lg"] != null) return map["lg"];
                if (w >= 768 && map["md"] != null) return map["md"];
                if (map["sm"] != null) return map["sm"];
                if (map["xs"] != null) return map["xs"];
                return null;
            };

            try {
                const parsed = JSON.parse(attr);
                if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
                    const val = pickBreakpointValue(parsed);
                    if (val != null) initialSlideIndex = parseInt(val, 10);
                } else {
                    initialSlideIndex = parseInt(parsed, 10);
                }
            } catch {
                initialSlideIndex = parseInt(attr, 10);
            }

            if (!Number.isInteger(initialSlideIndex) || initialSlideIndex < 0) initialSlideIndex = 0;

            const slideCount = sliderElement.querySelectorAll(".swiper-slide").length;
            if (slideCount > 0 && initialSlideIndex >= slideCount) initialSlideIndex = slideCount - 1;
        })();

        if (numOfSlidesAttr == null || numOfSlidesAttr === "" || numOfSlidesAttr.toLowerCase() === "auto") {
            numOfSlides = "auto";
        } else {
            const parsedSlides = parseFloat(numOfSlidesAttr);
            if (Number.isNaN(parsedSlides) || parsedSlides <= 0) numOfSlides = 1;
            else numOfSlides = parsedSlides;
        }

        let USE_DESTROY_BELOW = false;
        const destroyBelow = parseInt(sliderElement.getAttribute("data-destroy-below"), 10);
        if (!Number.isNaN(destroyBelow)) USE_DESTROY_BELOW = true;

        const destroyAbove = parseInt(sliderElement.getAttribute("data-destroy-above"), 10);

        let bpSlides = null;
        let bpSpace = null;
        try {
            bpSlides = JSON.parse(sliderElement.getAttribute("data-breakpoints") || "null");
        } catch {}
        try {
            bpSpace = JSON.parse(sliderElement.getAttribute("data-space") || "null");
        } catch {}

        function buildOptions() {
            const options = {
                loop: loop,
                slidesPerView: bpSlides ? 1 : numOfSlides,
                centeredSlides: centeredSlides || false,
                watchOverflow: true,
                roundLengths: true,
                slidesPerGroup: slidesPerGroup,
                speed: speed,
                spaceBetween: defaultSpace,
                initialSlide: initialSlideIndex,
                observer: true,
                observeParents: true,
                resizeObserver: true,
                slidesOffsetAfter: getEndOffsetPx(),
                on: {
                    init(sw) {
                        applyEndOffset(sw);
                    },
                    breakpoint(sw) {
                        applyEndOffset(sw);
                    },
                },
            };

            if (bpSlides && typeof bpSlides === "object") {
                options.breakpoints = {};
                Object.keys(bpSlides)
                    .map((k) => parseInt(k, 10))
                    .filter((k) => !Number.isNaN(k))
                    .sort((a, b) => a - b)
                    .forEach((minWidth) => {
                        const slides = parseFloat(bpSlides[minWidth]);
                        const space = bpSpace && bpSpace[minWidth] != null ? parseInt(bpSpace[minWidth], 10) : defaultSpace;
                        options.breakpoints[minWidth] = { slidesPerView: slides, spaceBetween: space };
                    });
            }

            if (navigation) {
                options.navigation = {
                    nextEl: ".swiper-button-next.slider-" + sliderId,
                    prevEl: ".swiper-button-prev.slider-" + sliderId,
                };
            }

            if (autoplay) {
                options.autoplay = { delay: autoplayDelay, disableOnInteraction: false };
            }

            if (effect) {
                options.effect = effect;
                if (effect === "fade") options.fadeEffect = { crossFade: fadeCrossFade };
            }

            if (pagination) {
                const base = { el: ".swiper-pagination" };
                if (paginationType === "fraction") options.pagination = { ...base, type: "fraction" };
                else if (paginationType === "progressbar") options.pagination = { ...base, type: "progressbar" };
                else options.pagination = { ...base, clickable: true };
            }

            return options;
        }

        function ensureMobileVideoAttributes(enableAutoplay) {
            const vids = sliderElement.querySelectorAll("video");
            vids.forEach((v) => {
                v.muted = true;
                v.playsInline = true;
                v.setAttribute("muted", "");
                v.setAttribute("playsinline", "");
                if (enableAutoplay) v.setAttribute("autoplay", "");
                else v.removeAttribute("autoplay");
                if (!v.getAttribute("preload")) v.setAttribute("preload", "auto");
            });
            return vids;
        }

        function playVideoSafe(video) {
            if (!video) return;
            video.muted = true;
            video.playsInline = true;
            const p = video.play();
            if (p && typeof p.then === "function") p.catch(() => {});
        }

        function pauseAndReset(video) {
            try {
                video.pause();
                video.currentTime = 0;
            } catch {}
        }

        function bindVideoSlideHandler(handler) {
            const swiper = sliderElement.swiper;
            if (!swiper) return;

            if (slideChangeVideoHandler && typeof swiper.off === "function") {
                swiper.off("slideChangeTransitionStart", slideChangeVideoHandler);
            }

            slideChangeVideoHandler = handler;
            swiper.on("slideChangeTransitionStart", slideChangeVideoHandler);
        }

        function shouldDestroy() {
            if (!Number.isNaN(destroyAbove) && window.innerWidth >= destroyAbove) return true;
            if (USE_DESTROY_BELOW && !Number.isNaN(destroyBelow) && window.innerWidth < destroyBelow) return true;
            return false;
        }

        function initSwiper() {
            if (sliderElement.swiper) return;
            sliderElement.swiper = new Swiper(sliderElement, buildOptions());
            applyEndOffset(sliderElement.swiper);
            if (hasVideoAutoPlay) {
                handleVideoPlayback();
            } else {
                handleVideoPause();
            }
        }

        function destroySwiper() {
            const inst = sliderElement.swiper;
            if (!inst) return;

            inst.destroy(true, true);
            sliderElement.swiper = null;
            slideChangeVideoHandler = null;

            const wrapper = sliderElement.querySelector(".swiper-wrapper");
            if (wrapper) wrapper.removeAttribute("style");
            sliderElement.querySelectorAll(".swiper-slide").forEach((s) => s.removeAttribute("style"));
        }

        function ensureState() {
            if (shouldDestroy()) destroySwiper();
            else initSwiper();
        }

        ensureState();

        let rAf = 0;
        window.addEventListener(
            "resize",
            () => {
                if (rAf) cancelAnimationFrame(rAf);
                rAf = requestAnimationFrame(() => {
                    ensureState();
                    applyEndOffset(sliderElement.swiper);
                    if (hasVideoAutoPlay) handleVideoPlayback(true);
                    else handleVideoPause();
                });
            },
            { passive: true },
        );

        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
                if (hasVideoAutoPlay) handleVideoPlayback(true);
                else handleVideoPause();
            }
        });

        function handleVideoPlayback(forceRewire = false) {
            const swiper = sliderElement.swiper;
            if (!swiper) return;

            const allVideos = ensureMobileVideoAttributes(true);
            if (allVideos.length === 0) return;

            const activeSlideOnInit = swiper.slides[swiper.activeIndex];
            const activeVideoOnInit = activeSlideOnInit && activeSlideOnInit.querySelector("video");

            allVideos.forEach((video) => {
                if (video !== activeVideoOnInit) pauseAndReset(video);
            });

            playVideoSafe(activeVideoOnInit);

            const handler = () => {
                const activeSlide = swiper.slides[swiper.activeIndex];
                const activeVideo = activeSlide && activeSlide.querySelector("video");

                allVideos.forEach((video) => {
                    if (video !== activeVideo) setTimeout(() => pauseAndReset(video), 150);
                });

                playVideoSafe(activeVideo);
            };

            if (forceRewire) bindVideoSlideHandler(handler);
            else bindVideoSlideHandler(handler);
        }

        function handleVideoPause() {
            const swiper = sliderElement.swiper;
            if (!swiper) return;

            const allVideos = ensureMobileVideoAttributes(false);
            if (allVideos.length === 0) return;

            allVideos.forEach((video) => pauseAndReset(video));

            const handler = () => {
                const activeSlide = swiper.slides[swiper.activeIndex];
                const activeVideo = activeSlide && activeSlide.querySelector("video");

                allVideos.forEach((video) => {
                    if (video !== activeVideo) setTimeout(() => pauseAndReset(video), 150);
                });
            };

            bindVideoSlideHandler(handler);
        }
    });
})();
